import {
  REPORT_STRUCTURE_APP_ID,
  BANK_FIND_APP_ID,
  BANK_FIND_SUITE_ID,
} from "../../config";

/* eslint-disable @typescript-eslint/no-redeclare */

// Update Query/Filter

export const UPDATE_FILTER = "UPDATE_FILTER";
export type UPDATE_FILTER = typeof UPDATE_FILTER;

export const UPDATE_SEARCH = "UPDATE_SEARCH";
export type UPDATE_SEARCH = typeof UPDATE_SEARCH;

export const UPDATE_ROUTER = "UPDATE_ROUTER";
export type UPDATE_ROUTER = typeof UPDATE_ROUTER;

export const UPDATE_UI = "UPDATE_UI";
export type UPDATE_UI = typeof UPDATE_UI;

export const UPDATE_PAGINATION = "UPDATE_PAGINATION";
export type UPDATE_PAGINATION = typeof UPDATE_PAGINATION;

export const RESET_STATE = "RESET_STATE";
export type RESET_STATE = typeof RESET_STATE;

export const ADD_TO_MULTI_FILTER = "ADD_TO_MULTI_FILTER";
export type ADD_TO_MULTI_FILTER = typeof ADD_TO_MULTI_FILTER;

export const REMOVE_FROM_MULTI_FILTER = "REMOVE_FROM_MULTI_FILTER";
export type REMOVE_FROM_MULTI_FILTER = typeof REMOVE_FROM_MULTI_FILTER;

export const UPDATE_SORT = "UPDATE_SORT";
export type UPDATE_SORT = typeof UPDATE_SORT;

export const UPDATE_AGG_REPORT = "UPDATE_AGG_REPORT";
export type UPDATE_AGG_REPORT = typeof UPDATE_AGG_REPORT;

export const ADD_VALUE = "ADD_VALUE";
export type ADD_VALUE = typeof ADD_VALUE;

export const REMOVE_VALUE = "REMOVE_VALUE";
export type REMOVE_VALUE = typeof REMOVE_VALUE;

export const UPDATE_DISPLAY_FIELDS = "UPDATE_DISPLAY_FIELDS";
export type UPDATE_DISPLAY_FIELDS = typeof UPDATE_DISPLAY_FIELDS;

export const UPDATE_API_URLS = "UPDATE_API_URLS";
export type UPDATE_API_URLS = typeof UPDATE_API_URLS;

// Brower Location

export const READ_BROWSER_LOCATION_INTO_STATE =
  "READ_BROWSER_LOCATION_INTO_STATE";
export type READ_BROWSER_LOCATION_INTO_STATE = typeof READ_BROWSER_LOCATION_INTO_STATE;

export const UPDATE_BROWSER_LOCATION = "UPDATE_BROWSER_LOCATION";
export type UPDATE_BROWSER_LOCATION = typeof UPDATE_BROWSER_LOCATION;

export const SAVE_BROWSER_LOCATION_INTO_STATE =
  "SAVE_BROWSER_LOCATION_INTO_STATE";
export type SAVE_BROWSER_LOCATION_INTO_STATE = typeof SAVE_BROWSER_LOCATION_INTO_STATE;

// API calls

export const REQUEST_RESULTS = "REQUEST_RESULTS";
export type REQUEST_RESULTS = typeof REQUEST_RESULTS;

export const RECEIVE_RESULTS = "RECEIVE_RESULTS";
export type RECEIVE_RESULTS = typeof RECEIVE_RESULTS;

export const RECEIVE_RESULTS_FAILURE = "RECEIVE_RESULTS_FAILURE";
export type RECEIVE_RESULTS_FAILURE = typeof RECEIVE_RESULTS_FAILURE;

export const REQUEST_COLUMNS = "REQUEST_COLUMNS";
export type REQUEST_COLUMNS = typeof REQUEST_COLUMNS;

export const RECEIVE_COLUMNS = "RECEIVE_COLUMNS";
export type RECEIVE_COLUMNS = typeof RECEIVE_COLUMNS;

export const RECEIVE_COLUMNS_FAILURE = "RECEIVE_COLUMNS_FAILURE";
export type RECEIVE_COLUMNS_FAILURE = typeof RECEIVE_COLUMNS_FAILURE;

export const RECEIVE_FIELDS_FAILURE = "RECEIVE_FIELDS_FAILURE";
export type RECEIVE_FIELDS_FAILURE = typeof RECEIVE_FIELDS_FAILURE;

// UI Display

export const FILTERS_COLLAPSED = "FILTERS_COLLAPSED";
export type FILTERS_COLLAPSED = typeof FILTERS_COLLAPSED;

export const FILTERS_EXPANDED = "FILTERS_EXPANDED";
export type FILTERS_EXPANDED = typeof FILTERS_EXPANDED;

export const FILTER_DRILLDOWN = "FILTER_DRILLDOWN";
export type FILTER_DRILLDOWN = typeof FILTER_DRILLDOWN;

export const FILTER_DRILLUP = "FILTER_DRILLUP";
export type FILTER_DRILLUP = typeof FILTER_DRILLUP;

export const DATA_REQUESTED = "DATA_REQUESTED";
export type DATA_REQUESTED = typeof DATA_REQUESTED;

export const DATA_LOADED = "DATA_LOADED";
export type DATA_LOADED = typeof DATA_LOADED;

export const REQUEST_IN_PROGRESS = "REQUEST_IN_PROGRESS";
export type REQUEST_IN_PROGRESS = typeof REQUEST_IN_PROGRESS;

export const UPDATE_APP = "UPDATE_APP";
export type UPDATE_APP = typeof UPDATE_APP;

export const UPDATE_UUID = "UPDATE_UUID";
export type UPDATE_UUID = typeof UPDATE_UUID;

export const UPDATE_AGG = "UPDATE_AGG";
export type UPDATE_AGG = typeof UPDATE_AGG;

export const LOCATION_CHANGE = "@@router/LOCATION_CHANGE";
export type LOCATION_CHANGE = typeof LOCATION_CHANGE;

export const CALL_HISTORY_METHOD = "@@router/CALL_HISTORY_METHOD";
export type CALL_HISTORY_METHOD = typeof CALL_HISTORY_METHOD;

export const UPDATE_BANNER = "UPDATE_BANNER";
export type UPDATE_BANNER = typeof UPDATE_BANNER;

export const apiPathLookup: any = {
  "/": "",
  "/bankfind-suite": "",
  "/bankfind-suite/bankfind": "/institutions",
  "/bankfind-suite/bankfind/": "/institutions",
  "/bankfind-suite/oscr": "/history",
  "/bankfind-suite/oscr/": "/history",
};

export const appPathLookup: any = {
  "/": BANK_FIND_SUITE_ID,
  "/bankfind": BANK_FIND_SUITE_ID,
  "/bankfind/": BANK_FIND_SUITE_ID,
  "/oscr": BANK_FIND_SUITE_ID,
  "/oscr/": BANK_FIND_SUITE_ID,
  "/bankfind-suite": BANK_FIND_SUITE_ID,
  "/bankfind-suite/": BANK_FIND_SUITE_ID,
  "/bankfind-suite/bankfind": BANK_FIND_APP_ID,
  "/bankfind-suite/bankfind/": BANK_FIND_APP_ID,
  "/bankfind-suite/oscr": REPORT_STRUCTURE_APP_ID,
  "/bankfind-suite/oscr/": REPORT_STRUCTURE_APP_ID,
};
